import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { FaCalculator } from 'react-icons/fa';
import Calculator from './Calculator';
import Modal from 'react-modal'; // simple modal package (install if needed)

Modal.setAppElement('#root'); // Required for accessibility


const IncomeDetail = () => {
  const { state } = useLocation();

  // Initialize form state with passed data or defaults
  const [form, setForm] = useState({
    date: '',
    vendor: state?.vendor || '',
    phone: state?.phone || '',
    others: '',
    notes: '',
  });
   const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', form);
    // Add your logic to save or process the form
  };

  return (
    <div className="p-6  mx-auto text-gray-800">

      <div className="flex justify-end mb-4">
        <button onClick={() => setIsCalculatorOpen(true)} className="text-xl">
          <FaCalculator className="text-gray-700 hover:text-primary" />
        </button>
      </div>
      <h1 className="text-xl font-bold mb-4">Expense Detail</h1>

      <p className='text-black text-center'>Enter Amount</p>
       <p className='text-black text-center text-2xl'>$0.06</p>

      {/* Date */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Date</label>
        <input
          type="date"
          name="date"
          value={form.date}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded text-sm"
        />
      </div>

    

      {/* Notes */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1"> Income Type</label>
        <textarea
          name="notes"
          value={form.notes}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded text-sm"
          rows="3"
        />
      </div>


        {/* Others */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Others</label>
        <input
          type="text"
          name="others"
          value={form.others}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded text-sm"
        />
      </div>



      <button
        onClick={handleSubmit}
        className="w-full bg-primary text-white py-2 rounded mt-4"
      >
        Save
      </button>

       {/* Calculator Modal */}
      <Modal
        isOpen={isCalculatorOpen}
        onRequestClose={() => setIsCalculatorOpen(false)}
        className="bg-white p-6 rounded-md max-w-sm mx-auto mt-20 shadow-lg"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center"
      >
        <h2 className="text-lg font-bold mb-4">Calculator</h2>
        <Calculator onClose={() => setIsCalculatorOpen(false)} />
      </Modal>
    </div>
  );
};

export default IncomeDetail;
